import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import CoreDashboardHeader from '@ts-core/components/DashboardHeader';

import PeriodStatus from './PeriodStatus';
import StudentsInfo from './StudentsInfo';

const DashboardHeader = (props) => {
  const { course, loading, onToggleCourseStatus } = props;
  return (
    <CoreDashboardHeader course={course} loading={loading && !course?.name}>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        flexGrow={1}
        justifyContent="flex-end"
      >
        <PeriodStatus
          course={course}
          loading={loading && !course?._id}
          onToggleCourseStatus={onToggleCourseStatus}
        />
        <StudentsInfo course={course} loading={loading && !course?._id} />
      </Box>
    </CoreDashboardHeader>
  );
};

DashboardHeader.propTypes = {
  course: PropTypes.object,
  loading: PropTypes.bool,

  onToggleCourseStatus: PropTypes.func.isRequired,
};

DashboardHeader.defaultProps = {
  course: {},
  loading: false,
};

export default DashboardHeader;
